import { useEffect } from 'react'
import { Box } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'

import { SwitchField } from 'src/components/shared/ui/form/fields'
import { FormField } from 'src/enums/Form'
import { EscritosFormValues } from '../../../shared/types/escritosFormTypes'

function ReclamacionComunidad(): JSX.Element {
  const { values, setFieldValue } = useFormikContext<EscritosFormValues>()

  useEffect(() => {
    if (values[FormField.DATOS_RECLAMACION_COMUNIDAD] === false) {
      setFieldValue(FormField.DATOS_DEUDA_PARTIDO_JUDICIAL, false)
    }
    // eslint-disable-next-line
  }, [values[FormField.DATOS_RECLAMACION_COMUNIDAD]])

  return (
    <>
      <Box display="flex" flexDirection="row" sx={{ margin: '16px 0px 0px 16px', width: '100%' }}>
        <SwitchField
          id={FormField.DATOS_RECLAMACION_COMUNIDAD}
          label={t('components.reclamacion_comunidad.text')}
        />
      </Box>

      {values[FormField.DATOS_RECLAMACION_COMUNIDAD] === true && (
        <Box display="flex" flexDirection="row" sx={{ margin: '16px 0px 0px 16px', width: '100%' }}>
          <SwitchField
            id={FormField.DATOS_DEUDA_PARTIDO_JUDICIAL}
            label={t('components.deuda_partido_judicial.text')}
          />
        </Box>
      )}
    </>
  )
}

export default ReclamacionComunidad
